import axios from "axios";
import domain from "@/util/domain.js";
import {
  getIntegrationIdByName,
  addUserIntegration
} from "./integrationsUtils.js";

// Stack sga-lambda-lgaming (us-east-2), repo sgaOrgV2/SGA_lgaming. Não há stack
// de dev em us-east-2: o "dev" fica nulo para que um operador de teste nunca
// dispare postback real na LGaming.
const baseLambdaURLs = {
  dev: null,
  prod: "https://56xw6ooz49.execute-api.us-east-2.amazonaws.com/lgpb/",
};

const host = domain();
// Access-Control-Allow-* são headers de resposta: enviados na requisição, fazem
// o preflight do API Gateway falhar.
const headers = {
  "Content-Type": "application/json"
};

let operator;
const lGamingIntegrationId = getIntegrationIdByName("lGaming"); // = "4"

//? Constructor LGaming
class LGaming {
  constructor(
    lGamingActive = false,
    createUser = false,
    firstDeposit = false,
    baseLambdaURL = baseLambdaURLs.prod
  ) {
    this.lGamingActive = lGamingActive;
    this.createUser = createUser;
    this.firstDeposit = firstDeposit;
    this.baseLambdaURL = baseLambdaURL;
  }
}

//? Integrando ao Vue
export default {
  install(Vue) {
    Vue.prototype.$lgaming = async (action, userData, userId, tid, webmaster_id) => {

      // debug:
      // console.log('PLUGIN: $lgaming(action, userData, userId, tid, webmaster_id)');
      // console.log("action", action);
      // console.log("userData", userData);
      // console.log("userId", userId);
      // console.log("tid", tid);
      // console.log("webmaster_id", webmaster_id);

      //? Montando o Construtor do operador
      switch (host) {
        case "sysbet":
        case "cartola":
          operator = new LGaming(false, true, true, baseLambdaURLs.dev);
          break;
        case "betdasorte":
          // console.log('Configurando o Construtor da LGaming para dasorte');
          operator = new LGaming(true, true, true, baseLambdaURLs.prod);
          break;
        default:
          operator = new LGaming();
      }

      if (!operator.lGamingActive) return;

      //? Criação de Usuário - createUser
      if (action === "createUser" && operator.createUser) {

        // console.log('Entrando no If CreateUser');

        // Verificando a existência dos ids da Lgaming;
        if (!tid && !webmaster_id) {
          // console.log('Verificando a existência dos ids da Lgaming');
          return;
        };

        const body = {
          domain: host,
          user_id: tid,
          affiliate_id: webmaster_id,
        }

        // Enviando o PostBack de Registro;
        try {
          var responsePostBackREG = await axios.post(`${operator.baseLambdaURL}registration`, body, { headers });
          console.log('responsePostBackREG: ', responsePostBackREG.status);
        } catch (error) {
          console.log(error);
          return;
        }
        // Adicionando ClickId e WebmasterId da lGaming no Banco de Dados 
        // de forma concatenada, para ser enviado de volta a lGaming
        // quando o usuário realizar primeiro depósito(FTD) e novos depósitos;
        addUserIntegration(userId, `${tid}_#_${webmaster_id}`, "lGaming");
      }

      //? Depositos
      if (action === "deposit" && operator.firstDeposit) {

        // Recuperando os IDS (ClickId e WebmasterId) da Lgaming;
        Vue.prototype.$axios.post(
          "/player/profile/findPlayerIntegrationId",
          Vue.prototype.$formdata({ integration_id: lGamingIntegrationId })
        ).then(async resp => {

          const respUserData = resp.data.dados;
          console.log('respUserData: ' + respUserData);
          if (!respUserData.user_integration_id) return;

          // Tratando a Concatenação dos Ids;
          var ids = respUserData.user_integration_id.split("_#_");
          // console.log('ids');
          // console.log(ids);
          var l_tid = ids[0];
          var l_webmasterId = ids[1];

          const body = {
            domain: host,
            user_id: l_tid,
            affiliate_id: l_webmasterId,
          }

          // Enviando para a Lgaming
          const responsePostBackFTD = await axios.post(`${operator.baseLambdaURL}first_deposit`, body, { headers });
          console.log('responsePostBackFTD: ', responsePostBackFTD.status);

        }).catch((e) => { console.log(e); });
      }
    };
  }
};